import { forwardRef, type ImgHTMLAttributes } from 'react';

import { cx } from '../../utils/cx';

import styles from './empty_state.module.css';

export type EmptyStateImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'alt'
> & {
  /** Illustrations are decorative by default; pass text only if the image carries meaning the heading and text do not. */
  alt?: string;
};

/**
 * EmptyStateImage - illustration sub-component for empty states.
 *
 * Renders a custom image (typically an SVG imported as a URL) in place of
 * `EmptyStateIcon`.
 */
export const EmptyStateImage = forwardRef<
  HTMLImageElement,
  EmptyStateImageProps
>(({ className, alt = '', ...rest }, ref) => {
  return (
    <img
      ref={ref}
      alt={alt}
      className={cx([styles.image, className])}
      {...rest}
    />
  );
});
